<template>
    <main>
        <header class=" bg-gradient-to-br from-[#FFD200] to-[#CD7D00]">
            <div
                class="container xl:max-w-[1280px]  text-center flex justify-center  lg:min-h-[512px] 2xl:min-h-[600px] 3xl:min-h-[650px]">
            </div>
        </header>

        <section class="mt-[586px] md:mt-[580px] lg:mt-[0px]">
            <div class="container xl:max-w-[1350px] mx-auto py-10 xl:py-10 2xl:py-10 3xl:py-16  sm:px-5 px-5">
                <div
                    class="p-3 xl:p-5 grid grid-cols-1 lg:grid-cols-2 gap-3 xl:gap-5 bg-white border border-linear rounded-3xl -translate-y-[560px] sm:-translate-y-[520px] md:-translate-y-[510px] lg:-translate-y-[510px] xl:-translate-y-[483px] 2xl:-translate-y-[480px] 3xl:-translate-y-[650px]">
                    <div class="space-y-3 xl:space-y-4">
                        <h4
                            class="text-linear font-inter text-lg lg:text-xl xl:text-[22px] font-semibold text-center rounded-t-xl shadow-[inset_0_4px_10px_0px_rgba(0,0,0,0.1)] py-4">
                            Get a quote without signing up</h4>
                        <div class="py-3 px-3 xl:py-5 rounded-xl shadow-[inset_0_0_2px_0.35px_rgba(0,0,0,0.1)]">
                            <div class="leading-none">
                                <div class="py-0 xl:py-0 px-0.5 grid gap-3 grid-cols-1 md:grid-cols-3 items-start">
                                    <!-- Ship From -->
                                    <div>
                                        <label class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">Ship
                                            From</label>
                                        <div class="relative w-full ">
                                            <i
                                                class="fa-solid fa-location-dot absolute  top-1/2 -translate-y-1/2 text-[#CD7D00]"></i>

                                            <select v-model="form.ship_from_country_code" class="w-full pl-5 pr-8 py-2 text-xs sm:text-sm text-gray-900
                                                        bg-transparent border-0 border-b border-gray-300
                                                         focus:outline-none focus:border-[#CD7D00] appearance-none">
                                                <option value="US">United States</option>
                                            </select>
                                        </div>
                                        <!-- <div>
                                            <VueSelect class="countries-select" v-model="form.ship_from_country_code"
                                                :options="[]" placeholder="United States" />
                                            <span class="text-red-600 text-xs">{{ errors.ship_from_country_code
                                            }}</span>
                                        </div> -->
                                    </div>

                                    <!-- Zip Code + State -->

                                    <div>
                                        <label class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">Zip
                                            Code</label>
                                        <div class="relative w-full">
                                            <div
                                                class="absolute inset-y-0 left-0 flex items-center pointer-events-none text-[#CD7D00]">
                                                <i class="fas fa-list"></i>
                                            </div>
                                            <input v-model="form.ship_from_postal_code"
                                                class="border-b border-gray-300 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 block w-full pl-6 py-2 outline-none bg-transparent" />
                                        </div>
                                        <span class="text-red-600 text-xs">{{ errors.ship_from_postal_code }}</span>
                                    </div>

                                    <div>
                                        <label
                                            class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">State</label>
                                        <div class="relative w-full">
                                            <!-- kill native arrow + keep only bottom border -->
                                            <!-- <select v-model="form.ship_from_state"
                                                    style="-webkit-appearance:none;-moz-appearance:none;appearance:none"
                                                    class="w-full py-2 text-xs sm:text-sm text-gray-900 bg-transparent border-0 border-b border-gray-300 focus:outline-none focus:border-[#CD7D00]">
                                                    <option value="">Select</option>
                                                    <template v-for="state in states" :key="state.id">
                                                        <option :value="state.abbr">{{ state.name }}</option>
                                                    </template>
</select> -->
                                        </div>

                                        <VueSelect class="countries-select" v-model="form.ship_from_state"
                                            :options="states" placeholder="Select" />

                                        <span class="text-red-600 text-xs">{{ errors.ship_from_country_code }}</span>
                                        <span class="text-red-600 text-xs">{{ errors.ship_from_state }}</span>
                                    </div>


                                    <!-- Ship To -->
                                    <div>
                                        <label class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">Ship
                                            To</label>
                                        <div class="relative w-full">
                                            <!-- <i
                                                class="fa-solid fa-location-dot absolute  top-1/2 -translate-y-1/2 text-[#CD7D00]"></i> -->

                                            <!-- kill native arrow, keep only bottom border -->
                                            <!-- <select v-model="form.ship_to_country_code"
                                                style="-webkit-appearance:none;-moz-appearance:none;appearance:none"
                                                class="w-full pl-5 pr-8 py-2 text-xs sm:text-sm text-gray-900 bg-transparent border-0 border-b border-gray-300 focus:outline-none focus:border-[#CD7D00]">
                                                <option value="">Choose a country</option>
                                                <template v-for="country in countries" :key="country.id">
                                                    <option :value="country.iso">{{ country.nicename }}</option>
                                                </template>
                                            </select> -->

                                            <VueSelect class="countries-select" v-model="form.ship_to_country_code"
                                                :options="countries" placeholder="Select a destination" />

                                            <!-- single custom arrow -->
                                            <!-- <i
                                                class="fa-solid fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none text-xs"></i> -->
                                        </div>
                                        <span class="text-red-600 text-xs">{{ errors.ship_to_country_code }}</span>
                                    </div>

                                    <!-- Zip Code + City -->

                                    <div>
                                        <label class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">Zip
                                            Code</label>
                                        <div class="relative w-full">
                                            <div
                                                class="absolute inset-y-0 left-0 flex items-center pointer-events-none text-[#CD7D00]">
                                                <i class="fas fa-list"></i>
                                            </div>
                                            <input v-model="form.ship_to_postal_code"
                                                class="border-b border-gray-300 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 block w-full pl-6 py-2 outline-none bg-transparent" />
                                        </div>
                                        <span class="text-red-600 text-xs">{{ errors.ship_to_postal_code }}</span>
                                    </div>

                                    <div>
                                        <label
                                            class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">City</label>
                                        <div class="relative w-full">
                                            <div
                                                class="absolute inset-y-0 left-0 flex items-center pointer-events-none text-[#CD7D00]">
                                                <i class="fa-solid fa-location-dot"></i>
                                            </div>
                                            <input v-model="form.ship_to_city"
                                                class="border-b border-gray-300 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 block w-full pl-5 py-2 outline-none bg-transparent" />
                                        </div>
                                        <span class="text-red-600 text-xs">{{ errors.ship_to_city }}</span>
                                    </div>


                                    <!-- Residential + Value -->

                                    <div>
                                        <label class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">
                                            Residential?</label>
                                        <div class="relative w-full">
                                            <select v-model="form.is_residential"
                                                style="-webkit-appearance:none;-moz-appearance:none;appearance:none"
                                                class="w-full pr-8 py-2 text-xs sm:text-sm text-gray-900 bg-transparent border-0 border-b border-gray-300 focus:outline-none focus:border-[#CD7D00]">
                                                <option :value="true">Yes</option>
                                                <option :value="false">No</option>
                                            </select>
                                        </div>
                                        <!-- <i
                                                class="fa-solid fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none text-xs"></i> -->

                                        <span class="text-red-600 text-xs">{{ errors.is_residential }}</span>
                                    </div>

                                    <div>
                                        <label class="block mb-1 text-xs sm:text-sm font-medium text-gray-900">Value
                                            <small class="text-gray-400">USD</small>
                                        </label>
                                        <div class="relative w-full">
                                            <div
                                                class="absolute inset-y-0 left-0 flex items-center pointer-events-none text-[#CD7D00]">
                                                <i class="fas fa-dollar"></i>
                                            </div>
                                            <input v-model="form.insurance_amount"
                                                class="border-b border-gray-300 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 block w-full pl-5 py-2 outline-none bg-transparent" />
                                        </div>
                                        <span class="text-red-600 text-xs">{{ errors.insurance_amount }}</span>
                                    </div>

                                </div>

                                <!-- Package / Weight / Dimensions -->
                                <div>
                                    <div class="grid grid-cols-5 gap-2 xl:gap-4 mt-6">
                                        <label
                                            class="col-span-1 text-xs sm:text-sm font-medium text-[#2E2E2E]">Pkgs</label>
                                        <label class="col-span-1 text-xs sm:text-sm font-medium text-[#2E2E2E]">Weight
                                            <small class="text-gray-400 text-[61%] sm:text-[80%]">lbs</small>
                                        </label>
                                        <label
                                            class="col-span-3 text-xs sm:text-sm font-medium text-[#2E2E2E] whitespace-nowrap">
                                            Dimensions <small class="inline text-[61%] sm:text-[80%]">(L x W x
                                                H)</small>
                                            <small class="text-gray-400 text-[61%] sm:text-[80%] ml-1">inch</small>
                                        </label>
                                    </div>

                                    <div class="space-y-3.5 pr-2">
                                        <template v-for="(dimension, index) in form.dimensions" :key="dimension.id">
                                            <div class="grid grid-cols-5 gap-2 py-2.5 relative"
                                                :class="{ 'px-2.5': form.dimensions.length !== (index + 1) }">

                                                <!-- 1.  Packages  -->
                                                <div class="relative w-full">
                                                    <i
                                                        class="fa-solid fa-box absolute left-2 top-1/2 -translate-y-1/2 text-[#CD7D00] text-xs"></i>
                                                    <input v-model="dimension.no_of_pkg"
                                                        class="border-b border-gray-400 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 w-full pl-7 py-2 outline-none bg-transparent" />
                                                </div>

                                                <!-- 2.  Weight  -->
                                                <div class="relative w-full">
                                                    <i
                                                        class="fa-solid fa-weight-hanging absolute left-2 top-1/2 -translate-y-1/2 text-[#CD7D00] text-xs"></i>
                                                    <input v-model="dimension.weight"
                                                        class="border-b border-gray-400 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 w-full pl-7 py-2 outline-none bg-transparent" />
                                                </div>

                                                <!-- 3.  Length  -->
                                                <div class="relative w-full">
                                                    <i
                                                        class="fa-solid fa-ruler-horizontal absolute left-2 top-1/2 -translate-y-1/2 text-[#CD7D00] text-xs"></i>
                                                    <input v-model="dimension.length"
                                                        class="border-b border-gray-400 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 w-full pl-7 py-2 outline-none bg-transparent" />
                                                </div>

                                                <!-- 4.  Width  -->
                                                <div class="relative w-full">
                                                    <i
                                                        class="fa-solid fa-ruler-combined absolute left-2 top-1/2 -translate-y-1/2 text-[#CD7D00] text-xs"></i>
                                                    <input v-model="dimension.width"
                                                        class="border-b border-gray-400 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 w-full pl-7 py-2 outline-none bg-transparent" />
                                                </div>

                                                <!-- 5.  Height  -->
                                                <div class="relative w-full">
                                                    <i
                                                        class="fa-solid fa-ruler-vertical absolute left-2 top-1/2 -translate-y-1/2 text-[#CD7D00] text-xs"></i>
                                                    <input v-model="dimension.height" p
                                                        class="border-b border-gray-400 text-gray-900 text-xs sm:text-sm focus:border-[#CD7D00] focus:ring-0 w-full pl-7 py-2 outline-none bg-transparent" />
                                                </div>

                                                <!-- Remove Button -->
                                                <button v-if="form.dimensions.length !== (index + 1)"
                                                    @click="removeDimension(index)"
                                                    class="rounded-full h-6 w-6 text-sm bg-red-500 text-white absolute top-[0.8rem] -right-2"
                                                    type="button"><i class="fas fa-close"></i></button>
                                            </div>
                                        </template>

                                        <!-- Add Item -->
                                        <div class="mt-6 space-y-3">
                                            <button @click="addDimension"
                                                class="w-full max-w-[160px] mb-8 bg-gray-50 border border-gray-400 shadow-[inset_0_0_2px_0.35px_rgba(0,0,0,0.1)] text-[#2E2E2E] py-2 rounded-md flex justify-center items-center text-sm cursor-pointer hover:shadow-md">
                                                Add Item +
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Get Rates -->
                                <div class="flex justify-center items-center py-2">
                                    <button @click="showResults"
                                        class="border-[3px] border-linear bg-gradient-to-r from-[#FFD200] to-[#CD7D00] px-16 py-4 text-white rounded- hover:font-bold hover:border-0">
                                        {{ loading ? 'Loading ...' : 'Get Rates' }}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="space-y-3 xl:space-y-4 h-full">
                        <!-- <h4
                            class="text-linear text-lg lg:text-xl xl:text-[22px] font-bold text-center rounded-t-xl shadow-[inset_0_4px_10px_0px_rgba(0,0,0,0.1)] py-5 lg:pb-8">
                            Results</h4> -->

                        <div class="h-full overflow-x-hidden">
                            <ResultComponent v-if="show_results" :rates="rates" :form="form" :loading="loading"
                                class="h-[580px] overflow-y-auto hide-scroll">
                            </ResultComponent>

                            <template v-else>
                                <div
                                    class="h-[580px] flex flex-col  items-center py-3 px-5 xl:px-8 xl:py-8 rounded-xl shadow-[inset_0_0_2px_0.35px_rgba(0,0,0,0.1)]">
                                    <img class="h-30 w-42 sm:h-36 sm:w-52  animate-float  3xl:h-44 3xl:w-64 rounded-full object-contain"
                                        src="../assets/logo.svg" alt="logo">
                                    <h2
                                        class="mt-1 md:mt-2 text-center text-[14px] sm:text-[30px] font-inter font-semibold  text-black">
                                        Effortless Shipping with <br>
                                        <span class="text-linear">Self Ship Label</span>
                                    </h2>
                                </div>
                            </template>



                        </div>

                    </div>
                </div>
            </div>
        </section>

        <section class="mt-[-600px] sm:mt-[-500px] 3xl:mt-[-600px] overflow-x-hidden">
            <div
                class="container xl:max-w-[1280px] mx-auto py-10 xl:py-10 2xl:py-10 3xl:py-16 3xl:pb-0 2xl:pb-0 xl:px-10 sm:px-5 px-5 grid grid-cols-1 lg:grid-cols-2 justify-items-center lg:justify-items-stretch gap-10 lg:gap-0">


                <div data-aos="fade-right" class="flex flex-col justify-center">
                    <h3
                        class="md:text-lg 2xl:text-[22px] font-medium lg:leading-7 tracking-wide font-inter text-[#2E2E2E]">
                        <span class="text-linear">Experience</span> Effortless Shipping
                    </h3>
                    <h2
                        class="mt-1 md:mt-2 text-left font-inter text-[1.2rem] md:text-[2.1rem] lg:text-[2.6rem] xl:text-[2.85rem] 2xl:text-[3rem] leading-tight font-semibold  text-black">
                        All-in-One Shipping Made <span class="text-linear">Effortless</span>
                    </h2>
                    <p
                        class="mt-2 lg:mt-3 xl:mt-6 2xl:text-lg font-rubik lg:leading-8 text-[#676767] xl:max-w-2xl sm:text-left">
                        Shipping packages worldwide is now a breeze with Self Ship Label. Take charge of your shipments
                        with
                        our user-friendly platform, designed to simplify the process. Whether you're sending gifts or
                        managing global orders, Self Ship Label ensures a smooth, reliable experience from start to
                        finish.
                        Trust us to handle your shipping needs with ease and confidence.</p>
                    <div class="mt-4 lg:mt-6 flex items-center gap-2 font-medium lg:h-[50px]">
                        <router-link to="/about"><button
                                class="bg-gradient-to-r from-[#FFD200] to-[#CD7D00] px-10 py-2 xl:px-12 xl:py-2.5 text-white rounded-md hover:shadow-md hover:rounded-sm transition-all">About</button></router-link>
                        <router-link to="/contact-us"><button
                                class="border-[1px] border-linear px-6 py-1.5 xl:px-10 xl:py-2 bg-white text-[#EEB500] rounded-md hover:bg-gradient-to-r hover:from-[#FFD200] hover:to-[#CD7D00] hover:text-white hover:py-2.5 hover:px-11 hover:shadow-md hover:rounded-sm hover:border-0 transition-all">Contact
                                us</button></router-link>
                    </div>
                </div>

                <div data-aos="fade-left"
                    class="flex flex-col gap-3 sm:gap-5 items-start lg:items-start justify-start w-full">
                    <!-- Card 1 -->
                    <div
                        class="w-full sm:w-[65%] flex justify-center items-center gap-4 rounded-full bg-gradient-to-br from-[#FFD200] to-[#CD7D00] p-0.5 border shadow-lg">
                        <div class="w-full h-[65px] sm:h-[80px] bg-white rounded-full flex justify-center items-center">
                            <img class="w-[132px] sm:w-[162px] object-contain h-[35px] sm:h-[45px] rounded-full bg-white"
                                src='../assets/images/calc/fedex_logo.png' alt="">
                        </div>
                    </div>
                    <!-- Card 2 -->
                    <div
                        class="w-full sm:w-[65%] self-end flex justify-center items-center gap-4 rounded-full bg-gradient-to-br from-[#FFD200] to-[#CD7D00] p-0.5 border shadow-lg">
                        <div class="w-full h-[65px] sm:h-[80px] bg-white rounded-full flex justify-center items-center">
                            <img class="w-[150px] sm:w-[200px] object-contain h-[50px] sm:h-[60px] rounded-full bg-white"
                                src='../assets/images/calc/dhl_logo.png' alt="">
                        </div>
                    </div>
                    <div
                        class="w-full sm:w-[65%] flex justify-center items-center gap-4 rounded-full bg-gradient-to-br from-[#FFD200] to-[#CD7D00] p-0.5 border shadow-lg">
                        <div class="w-full h-[65px] sm:h-[80px] bg-white rounded-full flex justify-center items-center">
                            <img class="w-[150px] sm:w-[182px] object-contain h-[55px] sm:h-[75px] rounded-full bg-white"
                                src='../assets/images/calc/ups_big.svg' alt="">
                        </div>
                    </div>

                    <div
                        class="w-full sm:w-[65%] self-end flex justify-center items-center gap-4 rounded-full bg-gradient-to-br from-[#FFD200] to-[#CD7D00] p-0.5 border shadow-lg">
                        <div class="w-full h-[65px] sm:h-[80px] bg-white rounded-full flex justify-center items-center">
                            <img class="w-[150px] sm:w-[182px] object-contain h-[35px] sm:h-[45px] rounded-full bg-white"
                                src='../assets/images/calc/usa_postal_logo.png' alt="">
                        </div>
                    </div>
                    <div
                        class="w-full sm:w-[65%] flex justify-center items-center gap-4 rounded-full bg-gradient-to-br from-[#FFD200] to-[#CD7D00] p-0.5 border shadow-lg">
                        <div class="w-full h-[65px] sm:h-[80px] bg-white rounded-full flex justify-center items-center">
                            <img class="w-[142px] sm:w-[182px] object-contain h-[50px] sm:h-[65px] rounded-full bg-white"
                                src='../assets/images/calc/xps_logo.png' alt="">
                        </div>
                    </div>

                </div>

            </div>
        </section>
        <!-- ============== SECTION =============  -->
        <section class="overflow-hidden sm:mt-20">
            <div class="container xl:max-w-[1280px] mx-auto py-10 xl:py-5 2xl:py-10 xl:px-10 sm:px-5 px-5">

                <div class="flex flex-col justify-center text-center">
                    <h3 class="md:text-lg 2xl:text-[22px] font-medium lg:leading-7  font-inter text-[#2E2E2E]">
                        <span class="text-linear">Common</span> Concerns, Clear Answers
                    </h3>
                    <h2
                        class="mt-1 md:mt-2 text-[1.5rem] md:text-[2.1rem] lg:text-[2.6rem] xl:text-[2.85rem] 2xl:text-[3rem] leading-tight font-bold font-inter  text-[#2E2E2E]">
                        Frequently Asked <span class="text-linear">Questions</span></h2>
                </div>
                <div class="pt-5 xl:pt-10 pb-10">
                    <div data-aos="fade-up"
                        class="bg-gradient-to-br from-[#FFD200] to-[#CD7D00] rounded-2xl p-1 md:p-1">
                        <div class="px-5 sm:px-5 lg:px-10 py-4 rounded-2xl bg-white">
                            <div v-for="(item, index) in itemData" :key="index"
                                class="item py-0 mt-4 md:mt-6 overflow-hidden">
                                <a href="#"
                                    class="flex items-center justify-start gap-2 sm:gap-5 text-[1.05rem] lg:text-[1rem] pb-2 sm:pb-3 transition-all"
                                    :class="{ 'border-b-linear': index !== itemData.length - 1 }"
                                    @click.prevent="toggleItem(index)">
                                    <i
                                        :class="{ 'fa-solid fa-minus text-linear transition-all': item.itemCheck, 'fa-solid fa-plus text-linear transition-all': !item.itemCheck }"></i>
                                    <h4
                                        class="text-[#2E2E2E] text-[11px] whitespace-nowrap sm:text-[16px] font-semibold">
                                        {{
                                            item.itemHeading }}</h4>
                                </a>
                                <div class="overflow-hidden transition-all">
                                    <p class="mt-3 pl-2 sm:pl-9 transition-all  md:text-base text-justify sm:text-left"
                                        :class="{ 'text-[#676767] transition-all': item.itemCheck, 'h-0 transition-all': !item.itemCheck }">
                                        {{ item.itemPara }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </main>
</template>
<style>
/* utilities.css  (or inside <style scoped> in the component) */
.hide-scroll {
    -ms-overflow-style: none;
    /* IE 10+  */
    scrollbar-width: none;
    /* Firefox */
}

.hide-scroll::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Edge */
}

/* permanent slow float for the logo */
@keyframes float {
    0% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-6px);
    }

    100% {
        transform: translateY(0);
    }
}

.animate-float {
    animation: float 4s ease-in-out infinite;
}

@media screen and (max-width:375px) {
    .calc_heading {
        font-size: 17px !important;
        padding-top: 10px;
    }
}
</style>

<script>
import ResultComponent from './ResultComponent.vue';
import { onMounted } from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ref } from "vue";
import VueSelect from "vue3-select-component";

export default {
    data() {
        return {
            itemData: [
                {
                    itemCheck: false,
                    itemHeading: "What is Self Ship Label?",
                    itemPara: "Our cutting-edge technology, Self Ship Label, gives users the freedom to independently handle their international shipments. For tasks like getting quotations, selecting couriers, making online payments, attaching labels, and more, it provides an easy-to-use interface.",
                },
                {
                    itemCheck: false,
                    itemHeading: "How can I use Self Ship Label to get started?",
                    itemPara: "It's simple to get going! All you have to do is create an account with Self Ship Label to access the Self Ship Label portal. With the help of our user-friendly tools, you can start creating and managing your shipments as soon as you log in. Happy Shipping!",
                },
                {
                    itemCheck: false,
                    itemHeading: "Is Self Ship Label available for international shipping ?",
                    itemPara: "Yes! The purpose of Self Ship Label is to facilitate both local and international shipping. Our platform offers everything you need for a smooth shipping experience, regardless of whether you're exporting locally or internationally.",
                },
                {
                    itemCheck: false,
                    itemHeading: "How does the shipping calculator work ?",
                    itemPara: "The destination, package weight, and dimensions are just a few of the details our shipping calculator uses to offer you instant quotations. It lets you select the shipping option that would save you the most money by comparing prices from different couriers.",
                },
                {
                    itemCheck: false,
                    itemHeading: "Do you have any extra or secret fees?",
                    itemPara: "Transparency is something we value. Our shipping calculator generates prices that include all applicable taxes and fees. There are no additional fees; you only pay what is shown.",
                },
                {
                    itemCheck: false,
                    itemHeading: "Which payment methods are available on Self Ship Label ?",
                    itemPara: "We accept multiple methods of payment, such as secure online payment platforms and popular credit cards. You can be sure that the highest level of security is being used for your transactions.",
                },
                {
                    itemCheck: false,
                    itemHeading: "Can I track my shipments with Self Ship Label ?",
                    itemPara: "Yes, you can! Every shipment processed through Self Ship Label comes with door-to-door tracking. Monitor the status of your package in real-time and stay informed throughout its journey.",
                },
                {
                    itemCheck: false,
                    itemHeading: "What if I need assistance during the shipping process ?",
                    itemPara: "Our customer support team is here to help! If you have any questions, concerns, or require assistance at any stage of the shipping process, feel free to reach out to our dedicated support team via the contact information provided on our website.",
                },
                {
                    itemCheck: false,
                    itemHeading: "How can I get a refund or make changes to my shipment ?",
                    itemPara: "For information on refunds or making changes to your shipment, please refer to our Terms and Conditions. If you need further assistance, contact our customer support, and we'll guide you through the process.",
                },
            ],
            loading: false,
            dimension_modal: false,
            show_results: false,
            countries: [],
            states: [],
            rates: [],
            length: "L",
            width: "W",
            height: "H",
            form: {
                user_id: 1,

                is_residential: true,
                ship_from_country_code: "US",
                ship_from_postal_code: "",
                ship_from_state: "",
                insurance_amount: "",
                ship_to_country_code: "",
                ship_to_city: "",
                ship_to_postal_code: "",
                address_type: true,
                dimensions: [
                    {
                        no_of_pkg: 1,
                        weight: "",
                        length: "",
                        width: "",
                        height: "",
                    }
                ],
                rate: {}
            },
            pkg: {},
            errors: {},
            shipDomestic: false,
        };
    },
    components: { ResultComponent, VueSelect },
    mounted() {
        this.fetchCountries();
        window.scrollTo(0, 0);
    },
    methods: {
        toggleItem(index) {
            this.itemData[index].itemCheck = !this.itemData[index].itemCheck;
        },
        openDimensionModal() {
            this.dimension_modal = true;
        },
        closeDimensionModal() {
            this.dimension_modal = false;
        },
        showResults() {
            this.show_results = true;
            this.fetchRates();
        },
        // fetchCountries() {
        //     const url = "data"
        //     this.$axios
        //         .post(url, {
        //             headers: this.$headers,
        //         })
        //         .then((response) => {
        //             this.countries = response.data.data.countries;
        //             this.states = response.data.data.states;
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //         });
        // },
        fetchCountries() {
            const url = "data";
            this.$axios
                .post(url, {}, { headers: this.$headers })
                .then((response) => {
                    const countries = response.data.data.countries;
                    this.countries = countries.map(country => ({
                        label: country.name,
                        value: country.iso,
                    }));
                    this.states = response.data.data.states;
                    this.states = this.states.map(state => ({
                        label: state.name,
                        value: state.abbr,
                    }));
                })
                .catch((error) => {
                    console.error("Error fetching countries:", error);
                });
        },
        fetchRates() {
            this.loading = true;
            this.dimension_modal = false;
            this.errors = {};
            const url = "rates"
            this.$axios
                .post(url, this.form, {
                    headers: this.$headers,
                })
                .then((response) => {
                    this.rates = response.data.data;
                    this.loading = false;
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.dimension_modal = true;
                    this.loading = false;
                });
        },
        setRate(rate) {
            this.form1.rate = rate;
            this.loading = true;
            this.errors = {};
            this.$axios
                .post("package/set-rate", this.form1, {
                    headers: this.$headers
                })
                .then((response) => {
                    console.log(response)
                })
                .catch((error) => {
                    this.errors = error.response;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchPackage() {
            this.loading = true;
            const url = "package/get-package"
            this.$axios
                .post(url, null, {
                    headers: this.$headers,
                })
                .then((response) => {
                    this.pkg = response.data.data.package;
                    this.loading = false;
                    this.form.ship_from_country_code = this.pkg.ship_from.country_code;
                    this.form.ship_from_postal_code = this.pkg.ship_from.zip_code;
                    this.form.ship_to_country_code = this.pkg.ship_from.country_code;
                    this.form.ship_to_postal_code = this.pkg.ship_from.zip_code;

                    let pieces = [];
                    this.pkg.boxes.forEach(function (value) {
                        let piece = {
                            length: value.length.toString(),
                            width: value.width.toString(),
                            weight: value.weight.toString(),
                            height: value.height.toString(),
                        };
                        pieces.push(piece);
                    });

                    this.form.dimensions = pieces;
                    this.loading = false;
                    this.fetchRates();
                    this.show_results = true;

                    this.length = this.form.dimensions[0].length;
                    this.width = this.form.dimensions[0].width;
                    this.height = this.form.dimensions[0].height;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        dimension(type) {
            if (type == 'length') {
                if (this.form.dimensions[0].length) {
                    this.length = this.form.dimensions[0].length;
                } else {
                    this.length = "L";
                }
            }

            if (type == 'width') {
                if (this.form.dimensions[0].width) {
                    this.width = this.form.dimensions[0].width;
                } else {
                    this.width = "W";
                }
            }

            if (type == 'height') {
                if (this.form.dimensions[0].height) {
                    this.height = this.form.dimensions[0].height;
                } else {
                    this.height = "H";
                }
            }
        },
        addDimension() {
            this.form.dimensions.push({
                weight: "",
                length: "",
                width: "",
                height: "",
            });
        },
        removeDimension(index) {
            this.form.dimensions.splice(index, 1);
            this.fetchRates();
        },
        getRates() {
            const element = document.getElementById('rates-form');
            element.scrollIntoView({ behavior: 'smooth' });
        },
        shipDomesticFunc(option) {

            this.shipDomestic = option === 'us';

            if (option == 'us') {
                this.form.ship_from_country_code = "US";
                this.form.ship_to_country_code = "US";
            } else {
                this.form.ship_to_country_code = "";
            }
        },
    },
    setup() {
        onMounted(() => {
            AOS.init({
                duration: 900,
                easing: 'ease-in-out',
                once: true,
            });
        });

        const selected = ref([])
        const options = [
            { label: 'Option #1', value: 'option_1' },
            { label: 'Option #2', value: 'option_2' },
            { label: 'Option #3', value: 'option_3' },
        ]

        return { selected, options }
    }
};
</script>

<style>
@media screen and (max-width:375px) {
    .calc_heading {
        font-size: 17px !important;
        padding-top: 10px;
    }
}

[type='text']:focus,
[type='email']:focus,
[type='url']:focus,
[type='password']:focus,
[type='number']:focus,
[type='date']:focus,
[type='datetime-local']:focus,
[type='month']:focus,
[type='search']:focus,
[type='tel']:focus,
[type='time']:focus,
[type='week']:focus,
[multiple]:focus,
textarea:focus,
select:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: inherit !important;
    /* keeps normal border */
}

.value-container[data-v-4645acad] {
    position: relative;
    overflow: hidden;
    display: grid;
    align-items: center;
    flex: 1 1 0%;
    padding: var(--vs-padding);
    height: 40px;
    background: rgb(209 213 219 / 10%);
}

.indicators-container[data-v-f0250ade] {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-shrink: 0;
    gap: var(--vs-indicators-gap);
    padding: var(--vs-padding);
    background: rgb(209 213 219 / 10%);
}
</style>